import type { ClientCard } from "../types";
import { appendAttribution, track } from "../session";

interface Props {
  card: ClientCard;
}

export function Card({ card }: Props) {
  return (
    <div class="card">
      <a
        class="card-link"
        href={appendAttribution(card.url, card.slug)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          track(`${card.type}_click`, card.slug, {
            title: card.title,
            url: card.url,
          })
        }
      >
        {card.thumbnailUrl && (
          <img
            class="card-thumb"
            src={card.thumbnailUrl}
            alt=""
            loading="lazy"
          />
        )}
        <div class="card-body">
          <div class="card-title">{card.title}</div>
          {card.meta.length > 0 && (
            <div class="card-meta">
              {card.meta.map((m) => (
                <span class="card-pill" key={`${m.label}-${m.value}`}>
                  <span class="card-pill-label">{m.label}:</span> {m.value}
                </span>
              ))}
            </div>
          )}
        </div>
      </a>
      {card.brochureUrl && (
        <a
          class="card-brochure"
          href={appendAttribution(card.brochureUrl, card.slug)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            track("brochure_request", card.slug, { title: card.title })
          }
        >
          Download brochure (PDF)
        </a>
      )}
    </div>
  );
}
